import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
let BooleanSelect = class BooleanSelect extends Vue {
};
__decorate([
    Prop(Boolean)
], BooleanSelect.prototype, "value", void 0);
__decorate([
    Prop(String)
], BooleanSelect.prototype, "trueValue", void 0);
__decorate([
    Prop(String)
], BooleanSelect.prototype, "falseValue", void 0);
BooleanSelect = __decorate([
    Component
], BooleanSelect);
export default BooleanSelect;
